import {
	SovosButton,
	SovosButtonsGroup,
	SovosCircularProgress,
	SovosDivider,
	SovosTypography,
} from 'mosaic-react';
import React from 'react';

import FormStepLayout from './FormStepLayout';

interface Step {
	name: string;
	value: string;
}

export const ReviewStep: React.FC<
	{
		onClickEdit: () => void;
	} & Step
> = ({ name, value, onClickEdit }) => (
	<>
		<SovosButtonsGroup>
			<SovosTypography variant='h6' sx={{ mr: 1 }}>
				{name}
			</SovosTypography>
			<SovosButton variant='text' onClick={onClickEdit}>
				Edit
			</SovosButton>
		</SovosButtonsGroup>
		<SovosTypography sx={{ my: 3 }}>{value}</SovosTypography>
		<SovosDivider sx={{ mb: 3, alignSelf: 'stretch' }} />
	</>
);

const StepReviewAndCreate: React.FC<{
	isSubmitting: boolean;
	onCreate: () => void;
	setCurrentStep: (step: number) => void;
	showError: boolean;
	steps: Step[];
}> = ({ isSubmitting, onCreate, setCurrentStep, showError, steps }) => {
	const errors = ['An error occurred, please review information and try again'];

	return (
		<FormStepLayout
			continueButton={
				<SovosButton disabled={isSubmitting} onClick={onCreate}>
					{isSubmitting ? <SovosCircularProgress size={20} /> : 'Create'}
				</SovosButton>
			}
			errors={errors}
			onContinue={onCreate}
			showErrors={showError}
			subTitle='Review your information before you create your rate file.'
			title='Review and create'
		>
			{steps.map(({ name, value }, i) => (
				<ReviewStep
					key={name}
					name={name}
					onClickEdit={() => setCurrentStep(i)}
					value={value}
				/>
			))}
		</FormStepLayout>
	);
};

export default StepReviewAndCreate;
